var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLockbox = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h40v40H0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M27.454 21v3.5h2.207c.048 0 .09.014.135.022v-3.544c-.045.008-.087.022-.135.022h-2.207Z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M27.454 26.5v2.017H11.841V11.483h15.613V13.5h2.207c.048 0 .09.014.135.022v-3.147c0-1.201-.66-1.875-1.836-1.875H11.336c-1.176 0-1.836.674-1.836 1.875v19.25c0 1.201.661 1.875 1.836 1.875H27.96c1.175 0 1.836-.674 1.836-1.875v-3.147c-.045.008-.087.022-.135.022h-2.207Z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M29.661 15.5h-2.207V19h2.207c.048 0 .09.014.135.022v-3.544c-.045.008-.087.022-.135.022ZM26.27 14.974v-.948c0-.29.296-.526.661-.526h.523v-2.017H11.841v17.034h15.613V26.5h-.523c-.365 0-.66-.235-.66-.526v-.948c0-.29.295-.526.66-.526h.523V21h-.523c-.365 0-.66-.235-.66-.526v-.948c0-.29.295-.526.66-.526h.523v-3.5h-.523c-.365 0-.66-.235-.66-.526Z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M29.796 15.478c.298-.05.526-.252.526-.504v-.948c0-.253-.228-.454-.526-.505M29.796 13.522c-.045-.008-.087-.022-.135-.022h-2.207M27.454 15.5h2.207c.048 0 .09-.014.135-.022"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M27.454 13.5h-.523c-.365 0-.66.236-.66.526v.948c0 .291.295.526.66.526h.523M29.796 20.978c.298-.05.526-.252.526-.504v-.948c0-.253-.228-.454-.526-.505M29.796 19.022c-.045-.008-.087-.022-.135-.022h-2.207M27.454 21h2.207c.048 0 .09-.014.135-.022"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M27.454 19h-.523c-.365 0-.66.236-.66.526v.948c0 .291.295.526.66.526h.523M29.796 26.478c.298-.05.526-.252.526-.504v-.948c0-.253-.228-.454-.526-.505M29.796 24.522c-.045-.008-.087-.022-.135-.022h-2.207M27.454 26.5h2.207c.048 0 .09-.014.135-.022"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M27.454 24.5h-.523c-.365 0-.66.236-.66.526v.948c0 .291.295.526.66.526h.523M19.911 24.629a4.63 4.63 0 0 0 4.636-4.63 4.63 4.63 0 0 0-4.636-4.627A4.63 4.63 0 0 0 15.275 20a4.63 4.63 0 0 0 4.636 4.629Z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M19.807 17.66a2.33 2.33 0 0 0-1.593.632l-2.72.093L17.464 20a2.34 2.34 0 0 0 2.343 2.34A2.34 2.34 0 0 0 22.15 20a2.34 2.34 0 0 0-2.343-2.34Z"
}))));
export default SvgLockbox;